import React, { useState } from "react";
import { Tabs } from "antd";
import SendReportsServer from "../SendReportsServer";
import "./PendingHoldTab.css";

const items = [
  {
    key: "1",
    label: "Pending",
    children: <SendReportsServer tab="pending" />,
  },
  {
    key: "2",
    label: "Hold",
    children: <SendReportsServer tab="hold" />,
  },
];
export default function PendingHoldTab() {
  const [activeKey, setActiveKey] = useState("1");

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <Tabs
      className="PendingHoldTab"
      activeKey={activeKey}
      onChange={handleTabChange}
      items={items}
      destroyInactiveTabPane
    />
  );
}
